<template>
  <div class="searchWrapper">
    <!-- <h4>Koppel opdracht aan tekenaar</h4> -->
    <input type="text" v-model="searchInput_tekenaarName" placeholder="Zoek een tekenaar" />
    <div class="searchResult" :class="{ selected: tekenaar.uid === selectedUserForKoppeling_byId }" @click="setSelectedUserForKoppeling_byId(tekenaar.uid)" v-for="(tekenaar, i) in filteredTekenaars.slice(0, 3)" :key="i">{{ tekenaar.userProfile.voornaam }} {{ tekenaar.userProfile.achternaam }}</div>
    <button @click="addTekenaarToOpdracht()" :class="{ usable: selectedUserForKoppeling_byId }">Nodig {{ selectedTekenaarVoornaam }} uit</button>
  </div>
</template>

<script>
import { db, fieldValue } from "@/firebase"

export default {
  data() {
    return {
      selectedUserForKoppeling_byId: "",
      searchInput_tekenaarName: ""
    }
  },
  watch: {
    searchInput_tekenaarName(newVal) {
      if (!newVal) return (this.selectedUserForKoppeling_byId = "")
    }
  },
  computed: {
    selectedTekenaarVoornaam() {
      if (!this.selectedUserForKoppeling_byId) return null
      return this.tekenaars.find(e => e.id === this.selectedUserForKoppeling_byId).userProfile?.voornaam
    },
    opdracht() {
      return this.$store.getters["opdracht/opdrachtData"]
    },
    tekenaars() {
      return this.$store.state.userAccounts
    },
    koppeling() {
      if (!this.selectedUserForKoppeling_byId) return
      const interestedUsers = this.opdracht?.afhandeling?.interestedUsers || []
      const arrayOfIds = interestedUsers.map(e => e.userId) || []

      let userProfilesOfInterestedUsers = []
      if (arrayOfIds.length) {
        userProfilesOfInterestedUsers = [...this.tekenaars].filter(user => {
          return arrayOfIds.includes(user.uid)
        })
      } else {
        userProfilesOfInterestedUsers = []
      }

      const losers = userProfilesOfInterestedUsers.map(e => {
        return { userId: e.uid, userEmail: e.userProfile.email, voornaam: e.userProfile.voornaam || "" }
      })

      const winner = [...this.tekenaars].find(user => user.uid === this.selectedUserForKoppeling_byId)
      const winnerFormatted = { userId: winner.uid, userEmail: winner.userProfile.email, voornaam: winner.userProfile.voornaam || "" }

      if (JSON.stringify(losers).includes(winnerFormatted.userId)) {
        const indexOfWinner = losers.findIndex(item => item.userId === winnerFormatted.userId)
        losers.splice(indexOfWinner, 1)
      }
      return {
        winner: winnerFormatted,
        losers: losers
      }
    },
    filteredTekenaars() {
      const tekenaars = [...this.tekenaars]
      if (this.searchInput_tekenaarName === "") return []
      return tekenaars.filter(tekenaar => {
        if (!tekenaar.userProfile) return
        const name = {
          firstName: tekenaar.userProfile.voornaam ?? "",
          lastName: tekenaar.userProfile.achternaam ?? ""
        }
        const fullName = `${name.firstName.toLowerCase() || ""} ${name.lastName.toLowerCase() || ""}`
        return fullName.includes(this.searchInput_tekenaarName.toLowerCase())
      })
    }
  },
  methods: {
    setSelectedUserForKoppeling_byId(e) {
      if (this.selectedUserForKoppeling_byId === e) return (this.selectedUserForKoppeling_byId = "")
      this.selectedUserForKoppeling_byId = e
    },
    addTekenaarToOpdracht() {
      if (confirm("Weet je zeker dat je deze tekenaar wilt koppelen? Let op! Je verstuurt hiermee ook automatisch een email aan de tekenaar die interesse hebben getoond maar de opdracht niet hebben gekregen.")) {
        db.doc(`opdrachten/${this.$store.state.opdracht.id}`).update({
          "afhandeling.tekenaar": this.selectedUserForKoppeling_byId,
          status: fieldValue.arrayUnion({
            event: 30,
            timestamp: new Date(),
            adminId: this.$store.state.adminId
          })
        })
        db.collection(`koppelingen`).add({
          ...this.koppeling,
          createdAt: new Date(),
          opdrachtNummer: this.opdracht?.metadata.opdrachtNummer,
          opdrachtGever: {
            naam: this.opdracht.opdrachtgever.naam,
            email: this.opdracht.opdrachtgever.email
          },
          tekenaar: {
            naam: this.koppeling.winner.voornaam
          }
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.searchWrapper
  h4
    font-weight: 600
    margin-bottom: 10px
  input
    margin-top: 10px
    background-color: rgba(0, 0, 0, 0.07)
    outline: none
    border: none
    width: 100%
    padding: 14px
    border-radius: 4px
  .searchResult
    background-color: rgba(0, 0, 0, 0.07)
    border-top: 1px solid rgba(0, 0, 0, 0.1)
    padding: 14px
    font-size: 12px
    transition: .1s
    font-weight: 600
    cursor: pointer
    &:hover
      color: white
      background-color: rgba(0, 0, 0, 0.6)

    &.selected
      background-color: rgba(0, 0, 0, 1)

      color: white

  button
    width: 100%
    outline: none
    border: none
    border-radius: 4px
    margin: 20px 0 0 0
    padding: 14px
    background-color: blue
    font-weight: 500
    color: white
    cursor: pointer
    pointer-events: none
    opacity: 0.5
    &.usable
      pointer-events: auto
      opacity: 1
</style>
